import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Field, useFormState } from 'react-final-form';
import deepEqual from 'deep-equal';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { Input } from '../../../../components/common-inputs';
import WithError from '../../../../components/with-error/WithError';
import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import DataBlock from '../../../../genie/components/predict-response/data-block/DataBlock';

import scss from './PredictForm.module.scss';

function PredictFormInner({ onSubmit, previousRequest }) {
  const { t } = useTranslation('genie');

  const brand = useSelector((state) => state.genieGo.brand);
  const isPredicting = useSelector((state) => state.genieGo.isPredicting);
  const isGeneratingAlternate = useSelector((state) => state.genieGo.isGeneratingAlternate);
  const predictedInitMessage = useSelector((state) => state.genieGo.predictedInitMessage);

  const { values } = useFormState();

  const isDirty = !deepEqual(previousRequest, values);

  return (
    <form className={scss.form} onSubmit={onSubmit}>
      <div className={scss.inputsBlock}>
        <div className={scss.inputsRow}>
          <WithLabel variant={LABEL_STYLES.ROW} label={`${t('brand')}:`} maxWidth={260} isBold>
            <Input type='text' size='sm' value={brand} isReadOnly />
          </WithLabel>

          <Field name='url' autoComplete='genie-predict-url'>
            {({ meta, input }) => (
              <WithLabel variant={LABEL_STYLES.ROW} label='URL:' maxWidth={300} isBold>
                <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                  <Input
                    type='text'
                    size='sm'
                    isError={meta.touched && meta.error}
                    formProps={input}
                    disabled={isPredicting}
                  />
                </WithError>
              </WithLabel>
            )}
          </Field>
        </div>

        <CommonButton
          type='submit'
          styleColor={BUTTON_STYLES.PRIMARY}
          maxWidth={180}
          className={scss.button}
          isLoading={isPredicting}
          disabled={!isDirty || isGeneratingAlternate}>
          {t('predictResponse')}
        </CommonButton>
      </div>

      <div className={scss.inputsBlock}>
        <Field name='message'>
          {({ meta, input }) => (
            <WithLabel
              variant={LABEL_STYLES.CUSTOM}
              label={`${t('message')}:`}
              isBold
              extraClassName={scss.textAreaField}
              maxWidth={600}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
                <CommonTextarea
                  name={input.name}
                  value={input.value}
                  onChange={input.onChange}
                  onFocus={input.onFocus}
                  onBlur={input.onBlur}
                  disabled={isPredicting}
                  isError={meta.touched && meta.error}
                  enableVoiceInput
                />
              </WithError>
            </WithLabel>
          )}
        </Field>

        {predictedInitMessage ? (
          <DataBlock
            r1={predictedInitMessage.interest}
            r2={predictedInitMessage.action}
            certainty={predictedInitMessage.uncertainty}
          />
        ) : null}
      </div>
    </form>
  );
}

export default PredictFormInner;
